import { Application, ApplicationAnswers, ApplicationQuestionGroup } from '@bybeam/platform-types';
import Typography from '@platform-ui-common/components/Typography/index.js';
import { isQuestionEnabled } from '@platform-ui/utilities/application/question.js';
import ApplicationQuestionReview from './ApplicationQuestionReview.js';

interface ApplicationQuestionGroupReviewProps {
  application: Application;
  applicationQuestionGroup: ApplicationQuestionGroup;
  sectionTitle: string;
}

export default function ApplicationQuestionGroupReview({
  application,
  applicationQuestionGroup,
  sectionTitle,
}: ApplicationQuestionGroupReviewProps): JSX.Element {
  const answers: Partial<ApplicationAnswers> = application?.answers ?? {};

  const enabledQuestions = applicationQuestionGroup.questions.filter((question) =>
    isQuestionEnabled(question, answers),
  );

  return (
    <>
      {sectionTitle !== applicationQuestionGroup.name && (
        <Typography variant="h3">{applicationQuestionGroup.name}</Typography>
      )}

      {enabledQuestions.map((applicationQuestion) => (
        <ApplicationQuestionReview
          key={applicationQuestion.key}
          application={application}
          applicationQuestion={applicationQuestion}
        />
      ))}
    </>
  );
}
